<template>
    <div class="min-h-screen flex flex-col sm:justify-center items-center pt-6 sm:pt-0 bg-gray-100">
        <div>
            <Link href="/">
                <h2 class="text-gray-600 font-bold text-3xl">Edit Level</h2>
            </Link>
        </div>

        <div class="w-full sm:max-w-md mt-6 px-6 py-4 bg-white shadow-md overflow-hidden sm:rounded-lg">
            <Head title="Submit Level"/>

            <BreezeValidationErrors class="mb-4"/>

            <div v-if="status" class="mb-4 font-medium text-sm text-green-600">
                {{ status }}
            </div>

            <form @submit.prevent="submit">
                <div>
                    <BreezeLabel for="title" value="Title"/>
                    <BreezeInput id="title" type="text" class="mt-1 block w-full" v-model="form.title"
                                 autofocus
                                 autocomplete="string" required/>
                </div>

                <div class="mt-4">
                    <BreezeLabel for="description" value="Description"/>
                    <BreezeInput id="description" type="text" class="mt-1 block w-full" v-model="form.description"
                                 required
                                 autocomplete="description"/>
                </div>

                <div class="block mt-4">
                    <label class="flex items-center">
                        <BreezeCheckbox name="update" v-model:checked="this.update" />
                        <span class="ml-2 text-sm text-gray-600">Update Level File</span>
                    </label>
                </div>

                <div v-if="update" class="mt-4">
                    <BreezeLabel for="string" value="Level File"/>
                    <!--<BreezeInput id="string" type="text" class="mt-1 block w-full" v-model="form.string" required
                                 autocomplete="string"/>-->
                    <input type="file" id="level"/>
                </div>

                <div class="flex items-center justify-end mt-4">
                    <BreezeButton class="ml-4" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                        Submit
                    </BreezeButton>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import BreezeButton from '@/Components/Button.vue'
import BreezeCheckbox from '@/Components/Checkbox.vue'
import BreezeGuestLayout from '@/Layouts/Guest.vue'
import BreezeInput from '@/Components/Input.vue'
import BreezeLabel from '@/Components/Label.vue'
import BreezeValidationErrors from '@/Components/ValidationErrors.vue'
import {Head, Link} from '@inertiajs/inertia-vue3';

export default {
    components: {
        BreezeButton,
        BreezeCheckbox,
        BreezeInput,
        BreezeLabel,
        BreezeValidationErrors,
        Head,
        Link,
        BreezeGuestLayout,
    },

    props: {
        errors: Object,
        auth: Object,
        level: Object,
    },

    data() {
        return {
            form: this.$inertia.form({
                title: this.level.title,
                description: this.level.description,
                string: this.level.string,
            }),
            update: false,
        }
    },

    methods: {
        submit() {
            if(this.update) {
                let fr = new FileReader();

                fr.onload = () => {
                    if(!/^[\x00-\xFF]*$/.test(fr.result.toString())) {
                        alert("Invalid level file! ASCII only.")
                        return;
                    }
                    this.form.string = fr.result;
                    this.form.post(this.route('snail::levels.update', this.level), {
                        onFinish: () => this.form.reset(),
                    })
                }

                fr.readAsText(document.getElementById('level').files[0]);
            } else {
                this.form.post(this.route('snail::levels.update', this.level), {
                    onFinish: () => this.form.reset(),
                })
            }
        }
    }
}
</script>
